// libraries import

import { useEffect } from "react";

// components imports
import ManagementCertification from "../../components/management_certification";
import Tabs from "../../components/tabs";
import WhyWorkWithUS from "../../components/whyWorkWithUs";
import GlobalBanner from "../../components/banner";
import EndingBanner from "../../components/endingBanner";
import Button from "../../components/button";

// data imports from JavaScript Object
import {
  aboutVisGroup,
  networkQualityPassion,
  tabs,
  tabsContent,
} from "../../utilities/aboutUsData";
import DefaultSpacing from "../../utilities/constants";

// images imports
import OurVisionImg from "../../assets/aboutus/images/OurVision.jpg";
import NetworkImg from "../../assets/aboutus/images/Networkimg.jpg";

//video imports
import bgVideo from "../../assets/aboutus/Videos/aboutUsVideo.mov";

const AboutUs = () => {
  useEffect(() => {
    document.title = "About Us";
    window.scroll({
      top: 0,
      behavior: "instant",
    });
  }, []);

  const defaultSpacing = new DefaultSpacing();
  const defaultPaddingX = defaultSpacing.getDefaultPaddingX();
  const defaultPaddingY = defaultSpacing.getDefaultPaddingY();
  const defaultGap = defaultSpacing.getDefaultGap();

  return (
    <main>
      <GlobalBanner bannerImg={bgVideo} backgroundGradient={true}>
        We Are <span className="text-visOrange">Vis Group</span>
      </GlobalBanner>
      <section className={`${defaultPaddingX} ${defaultPaddingY}`}>
        <div
          className={`grid grid-cols-1 place-items-center md:grid-cols-2 ${defaultGap}`}
        >
          <div className="col-span-1 w-full">
            <div className="space-y-5">
              <h1 className="text-normal font-semibold text-visBlue md:text-[2.0rem]">
                {aboutVisGroup.title}
              </h1>
              <p className="text-base md:text-[1.10rem]">
                {aboutVisGroup.disc}
              </p>

              <Button href={"/contactus"} origin={"origin-left"}>
                <span className="px-3 lg:px-14">Contact Us Now</span>
              </Button>
            </div>
          </div>
          <div className="col-span-1 h-full w-full overflow-hidden rounded-sm">
            <img
              className="aspect-video h-full max-w-full"
              src={aboutVisGroup.img}
              alt=""
            />
          </div>
        </div>
      </section>
      <section
        className={`${defaultPaddingY} ${defaultPaddingX} space-y-5 bg-visBlue-[200]`}
      >
        {/* <h1 className="text-center text-3xl font-bold md:text-5xl">
          <DancingLetters title={"We Are Vis Group"} />
        </h1>
        <p className="text-center text-base font-normal tracking-wide md:text-xl">
          Welcome to the Age of Digital Transformation
        </p> */}
        {/* Send the Array of the tabs*/}
        {/* dives should be the number of tabs */}
        <Tabs tabs={tabs} activeIndex={0}>
          {tabsContent.map((content, index) => {
            return (
              <section>
                <div
                  className={`grid grid-cols-1 place-items-center md:grid-cols-2 ${defaultGap}`}
                >
                  <div className="col-span-1 w-full">
                    <div className="space-y-5">
                      <h1 className="text-4xl font-semibold text-visBlue md:text-[2.0rem]">
                        {content.title}
                      </h1>
                      <p className="text-base md:text-[1.10rem]">
                        {content.disc}
                      </p>
                    </div>
                  </div>
                  <div className="col-span-1 h-full w-full overflow-hidden rounded-sm">
                    <img
                      className="aspect-video h-full max-w-full"
                      src={content.img}
                      alt=""
                    />
                  </div>
                </div>
              </section>
            );
          })}
        </Tabs>

        {/* </div> */}
      </section>
      <section className={`${defaultPaddingX} ${defaultPaddingY}`}>
        <div
          className={`grid grid-cols-1 place-items-center md:grid-cols-2 ${defaultGap}`}
        >
          <div className="col-span-1 h-full w-full overflow-hidden rounded-sm">
            <img
              className="h-full w-full"
              src={networkQualityPassion.img}
              alt=""
            />
          </div>
          <div className="col-span-1 w-full">
            <div className="space-y-5">
              <h1 className="lg:text-30 text-2xl font-semibold text-visBlue">
                {networkQualityPassion.title}
              </h1>
              <div>
                <p className="text-base md:text-[1.10rem]">
                  {networkQualityPassion.disc}
                </p>
              </div>

              {/* <Button href={"/contactus"} origin={"origin-left"}>
                <span className="px-3 lg:px-14">Contact Us Now</span>
              </Button> */}
            </div>
          </div>
        </div>
      </section>
      <section
        className={`${defaultPaddingX} md:px-[10vw] ${defaultPaddingY} bg-visBlue`}
      >
        <WhyWorkWithUS />
      </section>
      <section className={`bg-[#F5F4F4] ${defaultPaddingY} ${defaultPaddingX}`}>
        <ManagementCertification title={"We Are ISO Certified"} />
      </section>

      <EndingBanner buttonText="Contact Now" />
    </main>
  );
};

export default AboutUs;
